import {
  CapacitorBarcodeScanner,
  CapacitorBarcodeScannerCameraDirection,
  CapacitorBarcodeScannerTypeHint,
} from "@capacitor/barcode-scanner";
import { Capacitor } from "@capacitor/core";

export class BarcodeScanError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "BarcodeScanError";
  }
}

export const runBarcodeScan = async (): Promise<string> => {
  // Vérifier et demander la permission d'accès à la caméra sur le web
  if (Capacitor.getPlatform() === "web") {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: "environment" },
      });
      stream.getTracks().forEach((track) => track.stop());
    } catch (err: any) {
      if (
        err.name === "NotAllowedError" ||
        err.name === "PermissionDeniedError"
      ) {
        throw new BarcodeScanError(
          "Permission d'accès à la caméra refusée. Veuillez autoriser l'accès à la caméra dans votre navigateur.",
        );
      }
      throw new BarcodeScanError(
        "Une erreur est survenue lors de l'accès à la caméra. Veuillez réessayer.",
      );
    }
  }

  try {
    const code = await CapacitorBarcodeScanner.scanBarcode({
      hint: CapacitorBarcodeScannerTypeHint.QR_CODE,
      cameraDirection: CapacitorBarcodeScannerCameraDirection.BACK,
      web: { showCameraSelection: true },
    });
    if (code.ScanResult) {
      return code.ScanResult;
    }
  } catch (error) {
    throw new BarcodeScanError(
      "Une erreur est survenue lors du scan du QR code. Veuillez réessayer.",
    );
  }

  throw new BarcodeScanError("Aucun code scanné. Veuillez réessayer.");
};
